import { c as _c } from "react/compiler-runtime";
import "client-only";
import { usePathname } from "next/navigation";
import { useEffect, useEffectEvent, useRef } from "react";
type PathnameChangeCallback = (pathname: string, previousPathname: string) => void;

/**
 * Invoke a callback when the pathname changes in a Next.js application.
 * Automatically handles callback stability, so `useCallback` is NOT required.
 */

export function usePathnameChange(callback) {
  const $ = _c(7);
  const pathname = usePathname();
  const previousRef = useRef(pathname);
  let t0;
  if ($[0] !== callback) {
    t0 = (current, previous) => {
      callback(current, previous);
    };
    $[0] = callback;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onChange = useEffectEvent(t0);
  let t1;
  if ($[2] !== onChange || $[3] !== pathname) {
    t1 = () => {
      const previous_0 = previousRef.current;
      if (previous_0 !== pathname) {
        onChange(pathname, previous_0);
        previousRef.current = pathname;
      }
    };
    $[2] = onChange;
    $[3] = pathname;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== pathname) {
    t2 = [pathname];
    $[5] = pathname;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
}